// src/store/slices/wishlist-slice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  wishlistItems: []
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    addToWishlist(state, { payload }) {
      const id = payload?.id;
      if (id == null) return;
      const exists = state.wishlistItems.some(i => String(i.id) === String(id));
      if (!exists) state.wishlistItems.push(payload);
    },
    deleteFromWishlist(state, { payload }) {
      const id = typeof payload === 'object' ? payload.id : payload;
      if (id == null) return;
      state.wishlistItems = state.wishlistItems.filter(i => String(i.id) !== String(id));
    },
    deleteAllFromWishlist(state) {
      state.wishlistItems = [];
    },
    // optional convenience
    toggleWishlist(state, { payload }) {
      const id = payload?.id ?? payload;
      const idx = state.wishlistItems.findIndex(i => String(i.id) === String(id));
      if (idx === -1) {
        state.wishlistItems.push(typeof payload === 'object' ? payload : { id });
      } else {
        state.wishlistItems.splice(idx, 1);
      }
    }
  }
});

export const {
  addToWishlist,
  deleteFromWishlist,
  deleteAllFromWishlist,
  toggleWishlist
} = wishlistSlice.actions;

export default wishlistSlice.reducer;

// selectors
export const selectWishlistItems = (state) => state.wishlist.wishlistItems;
export const selectIsInWishlist = (state, id) =>
  state.wishlist.wishlistItems.some(i => String(i.id) === String(id));
